import { apiGet, apiPost } from './client.js';

export function createJob(projectId, isPreview = false) {
  return apiPost(`/api/projects/${projectId}/jobs${isPreview ? '?is_preview=true' : ''}`);
}
export function getJob(jobId) { return apiGet(`/api/jobs/${jobId}`); }
export function listJobs(projectId, limit = 50, offset = 0) {
  return apiGet(`/api/projects/${projectId}/jobs?limit=${limit}&offset=${offset}`);
}
export function downloadJob(jobId) {
  return apiPost(`/api/jobs/${jobId}/download`);
}
